import React, { useEffect, useRef, useState } from "react";
import ReactDOM from 'react-dom';
import { MonthNumber } from "../../constants/MonthNumber";
import { useDispatch, useSelector } from "react-redux";
import { ITimesheet } from "../../models";
import SwiperCore, { Navigation } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Years } from "../../constants/Years";
import { useParams, useSearchParams } from "react-router-dom";
import { useGlobalContext } from "../../GlobalContext";
import "../select/styles/select.scss"

SwiperCore.use([Navigation]);

interface ISelectDate {
	month: number
	year: number
	chosenYear: number
	onSwitch?: any;
	handleSetNewData?: any;
	onInit?: (list: HTMLElement) => void
	onChangeMonth: (value: number) => void
	onChangeYear: (value: number) => void
	//onChange: (month: number, year: number) => void
	value?: [number, number]
	minMax: {
		min: [number, number]
		max: [number, number]
	}
}

interface ISelectDateList {
	isActive: boolean
	isHaveMonth: string[]
	filedMonth: number | string
	handleChooseMonth: (month: number) => void
	fieldYear: number | string
	handleChangeYear: (year: number) => void
	chosenYear: number
	onClose: () => void
	target: React.RefObject<HTMLElement>
	onInit: (list: HTMLElement) => void
	minMax: {
		min: [number, number]
		max: [number, number]
	}
}

const SelectDateList: React.FC<ISelectDateList> = ({ isActive, handleChooseMonth, filedMonth, handleChangeYear, fieldYear, chosenYear, onClose, target, onInit, minMax }) => {

	const { timesheetId }: any = useParams(),
	dropdownRef = useRef<HTMLDivElement>(null),
	{ scrollY } = useGlobalContext();

	const [position, setPosition] = useState<{ top: number; left: number }>({ top: 0, left: 0 });

	function calcPosition() {
		if (target.current) {
			const { bottom, left, right, top } = target.current.getBoundingClientRect();
			if(window.innerWidth < 1280) {
				setPosition({ top: top + target.current.offsetHeight + scrollY, left: window.innerWidth - right });
			} else {
				setPosition({ top: bottom, left: left + window.scrollX });
			}
		}
	}
	
	useEffect(() => {
		window.addEventListener("resize", calcPosition)
		onInit(dropdownRef.current as HTMLElement);
	}, [dropdownRef.current]);

	useEffect(() => calcPosition, [isActive, target]);

	useEffect(() => {
		const handleClickOutside = (event: MouseEvent) => {
			if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node) && target.current && !target.current.contains(event.target as Node)) {
				onClose();
			}
		};

		document.addEventListener('mousedown', handleClickOutside);
		return () => document.removeEventListener('mousedown', handleClickOutside);
	}, [onClose, target]);

	return ReactDOM.createPortal(
		<div className={`select-date__list drop-down__block${isActive ? " is-active" : ""}`} ref={dropdownRef} style={{"--x": `${position.left}px`, "--y": `${position.top}px`} as React.CSSProperties}>
			<form className="section-table__change-full-date--months">
				<ul>
					{Object.keys(MonthNumber()).map((item, index) => {

						const isDisabled = chosenYear === minMax.max[0] ? +item > minMax.max[1]
						? true : false : false;

						return (
							<li
								key={`month-${item}`}
								className={
									isDisabled ? "is-disabled" : ""
								}
							>
								<label>
									<input
										type="radio"
										name="month"
										defaultValue={item}
										onChange={(event) => {
											if(isDisabled) {
												event.target.checked = false;
											} else {
												handleChooseMonth(+item)
											}
										}}
										
										checked={+item === filedMonth && chosenYear === fieldYear}
									/>
									<span>{MonthNumber()[index + 1].translate}</span>
								</label>
							</li>
						)
					})}
				</ul>
			</form>
			<form className="section-table__change-full-date--slider splide">
				<div className="splide__track">
					<Swiper
						slidesPerView={3}
						navigation={{
							nextEl: ".splide__arrow--next",
							prevEl: ".splide__arrow--prev",
						}}
						modules={[Navigation]}
						initialSlide={1}
					>
						{Years().map((year) => (
							<SwiperSlide key={year.year}>
								<li className="splide__slide">
									<label>
										<input
											disabled={timesheetId ?? year.isDisabled}
											onChange={() => {
												handleChangeYear(+year.year)
											}}
											defaultValue={+year.year}
											checked={chosenYear === +year.year}
											type="radio"
											name="year"
										/>
										<span>{year.year}</span>
									</label>
								</li>
							</SwiperSlide>
						))}
					</Swiper>
				</div>
				<div className="splide__arrows">
					<button className="splide__arrow splide__arrow--prev" type="button">
						<svg width="7" height="10" viewBox="0 0 7 10">
							<use xlinkHref="#arrow-prev"></use>
						</svg>
					</button>
					<button className="splide__arrow splide__arrow--next" type="button">
						<svg width="7" height="10" viewBox="0 0 7 10">
							<use xlinkHref="#arrow-next"></use>
						</svg>
					</button>
				</div>
			</form>
		</div>
	, document.body)
}

export const SelectDate: React.FC<ISelectDate> = ({
	month,
	year,
	chosenYear,
	onSwitch,
	onInit,
	onChangeMonth,
	onChangeYear,
	minMax,
	handleSetNewData,
}) => {
	const [isSelectActive, setIsSelectActive] = useState(false);

	const targetRef = useRef<HTMLDivElement>(null);
	const chosenTimesheet: ITimesheet = useSelector(
		(state: any) => state.toolkit.chosenTimesheet
	);
	const timesheet: ITimesheet[] = useSelector(
		(state: any) => state.toolkit.timesheet
	);
	const dispatch = useDispatch();

	const { timesheetId }: any = useParams();
	const [searchParams] = useSearchParams();

	/* const paramYear =
		searchParams.get("year") && Number(searchParams.get("year"));
	const paramMonth =
		searchParams.get("month") && Number(searchParams.get("month"));

	const [filedMonth, setFieldMonth] = useState(
		paramMonth ? paramMonth : `${month}`
	);
	
	const [fieldYear, setFieldYear] = useState(
		paramYear ? paramYear : year
	); */
	const [isHaveMonth, setIsHaveMonth] = useState<string[]>(["3"]);

	/* const getTasksAndExpenses = (
		month: string | number,
		year: string | number,
		timesheetId?: string
	) => {
		if (timesheetId || chosenTimesheet?.user?.id) {
			axios
				.get(
					getApiLink(
						`/api/timesheet/tasks/?month=${month}&year=${year}&user_id=${timesheetId ?? chosenTimesheet?.user?.id
						}`
					)
				)
				.then(({ data }) => {
					dispatch(setTasks(data));
				});
			axios
				.get(
					getApiLink(
						`/api/timesheet/expenses/?month=${month}&year=${year}&user_id=${timesheetId ?? chosenTimesheet?.user?.id
						}`
					)
				)
				.then(({ data }) => {
					dispatch(setExpenses(data));
				});

			return;
		}
	}; */

	const handleChooseMonth = (value: number) => {
		onChangeMonth(value);
	};

	const handleChangeYear = (value: number) => {
		onChangeYear(value);
	};

	return (
		<div
			ref={targetRef}
			className={
				isSelectActive
					? "select-date drop-down is-active"
					: "select-date drop-down"
			}
		>
			<button
				className="select-date__target drop-down__target"
				type="button"
				onClick={() => {
					setIsSelectActive((prev) => !prev)
				}}
			>
				<span>
					{month && MonthNumber()[month].translate}, {year}
				</span>
				<svg
					width="10"
					height="7"
					viewBox="0 0 10 7"
					className="select-date__target-arrow drop-down__target--arrow"
				>
					<use xlinkHref="#drop-down-arrow"></use>
				</svg>
			</button>
			<SelectDateList 
				target={targetRef}
				minMax={minMax}
				isActive={isSelectActive} 
				isHaveMonth={isHaveMonth} 
				filedMonth={month}
				handleChooseMonth={handleChooseMonth}
				fieldYear={year}
				handleChangeYear={handleChangeYear}
				chosenYear={chosenYear}
				onClose={() => setIsSelectActive(false)}
				onInit={(list) => onInit && onInit(list)}
			/>
		</div>
	);
};
